import { useState, useEffect } from "react"
import axios from "axios"
import api from "../config/backend"

const LeadsManagement = () => {
    const [employees, setEmployees] = useState()

    const domain = localStorage.getItem("domain")
    const token = localStorage.getItem("token")
    const _crm__token = localStorage.getItem("_crm__token")

    const fetchEmployees = async () => {
        const { data, status } = await axios.post(`${api}/Author/fetch-employees`, { token: _crm__token })

        console.log({ data })
    }

    useEffect(() => {
        fetchEmployees()
    }, [])

    return (
        <div className="_0dzk">
            Leads
        </div>
    )
}

export default LeadsManagement
